import { memo } from 'react'
import { Paper } from '@mui/material'
import { DomainOutlined, PersonOutlined } from '@mui/icons-material'
import { Tooltip, Caption, Stack, Radio, Body2 } from '@collaborate-health/uikit'
import { ContentReviewRequest } from '@tabeeb/contracts/main-api/swagger-main-api'

interface ActiveReviewProps {
  review: ContentReviewRequest
  isSelected: boolean
  setActiveReviewToUpdate: (review: ContentReviewRequest) => void
}

const ActiveReview: React.FC<ActiveReviewProps> = ({ review, isSelected, setActiveReviewToUpdate }) => {
  return (
    <Paper variant='outlined'>
      <Stack direction='row' p={0.5}>
        <Radio checked={isSelected} onClick={() => setActiveReviewToUpdate(review)} />
        <Stack overflow='hidden' flex={1}>
          <Tooltip text={review.TargetContentName} placement='top'>
            <Body2 noWrap>{review.TargetContentName}</Body2>
          </Tooltip>
          <Stack direction='row' spacing={1}>
            <Tooltip text={review.ReviewerName} placement='top'>
              <Stack direction='row' spacing={0.25} alignItems='center' maxWidth='48%'>
                <PersonOutlined fontSize='small' />
                <Caption noWrap>{review.ReviewerName}</Caption>
              </Stack>
            </Tooltip>
            <Tooltip text={review.ReviewerTenantName} placement='top'>
              <Stack direction='row' spacing={0.25} alignItems='center' maxWidth='48%'>
                <DomainOutlined fontSize='small' />
                <Caption noWrap>{review.ReviewerTenantName}</Caption>
              </Stack>
            </Tooltip>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default memo(ActiveReview)

